import React, { useState } from "react";
import { Box, Typography, Grid, TextField, Paper, CircularProgress } from "@mui/material";
import { storage } from "../../../firebase";
import { ref, uploadBytes, getDownloadURL } from "firebase/storage";

function Declaration({ studentId, form, handleChange }) {

  const [uploading, setUploading] = useState(null);

  const uploadImage = async (file, type) => {

    if (!file) return;

    try {

      setUploading(type);

      const storageRef = ref(
        storage,
        `signatures/${studentId}/${type}_${Date.now()}`
      );

      await uploadBytes(storageRef, file);

      const url = await getDownloadURL(storageRef);

      handleChange(type, url);

    } catch (err) {
      console.error(err);
    }

    setUploading(null);

  };

  const renderUpload = (type, label) => (
    <Grid className="col-sm-3 mb-3">
      <Typography>{label}</Typography>

      <Box sx={{ minHeight: 120, display: "flex", alignItems: "center" }}>
        
        {uploading === type && <CircularProgress size={30} />}

        {!uploading && form[type] && (
          <img
            src={form[type]}
            alt={label}
            style={{ width: 120, display: "block", marginBottom: 10 }}
          />
        )}

      </Box>

      <input
        type="file"
        accept="image/*"
        disabled={uploading === type}
        onChange={(e) => uploadImage(e.target.files[0], type)}
      />
    </Grid>
  );

  return (
    <Box display="flex" justifyContent="center" bgcolor="#f4f6f8">
      <Paper sx={{ p: 2, width: "100%" }}>

        <Box sx={{ background: "teal", color: "#fff", p: 1, mb: 3 }}>
          <Typography fontWeight="bold">
            9) Declaration by Parents / Guardian
          </Typography>
        </Box>

        <Grid className="row" spacing={3}>

          <Grid className="col-sm-6 mb-3">
            <TextField
              fullWidth
              label="Place"
              size="small"
              value={form.place || ""}
              onChange={(e) => handleChange("place", e.target.value)}
            />
          </Grid>

          <Grid className="col-sm-6 mb-3">
            <TextField
              fullWidth
              type="date"
              size="small"
              value={form.date || ""}
              onChange={(e) => handleChange("date", e.target.value)}
            />
          </Grid>

          {renderUpload("motherSignature", "Mother Signature")}
          {renderUpload("fatherSignature", "Father Signature")}
          {renderUpload("guardianSignature", "Guardian Signature")}

        </Grid>

      </Paper>
    </Box>
  );
}

export default Declaration;